import React, { useRef, useState } from "react";
import { FooterStyled } from "./styled";
import MailIcon from "../../assets/footerMail.webp";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  contactsMenu,
  footerContactUsText,
  footerCopyrightsText,
  footerDescription,
  shortsLinks,
} from "../../content/footer";
import logo from "../../assets/logo.svg";
import makeInIndia from "../../assets/makeInIndia.png";
import { contactUrl, homeUrl } from "../../content/route";
import Gst from "../../assets/GST.png";

const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const email = useRef("****")
  const [buttonDisabled, setButtonDisabled] = useState(false)

  const submitEmail = () =>{
    let data_send = {}
    data_send["Name"] = "NA"
    data_send["Email"] = email.current
    data_send["Subject"] = "NA"
    data_send["Company"] = "NA"
    data_send["Message"] = "NA"
    setButtonDisabled(true)
    pushToLoki(JSON.stringify(data_send))
  }

  async function pushToLoki(DATA) {
  try {
    const url = "https://api.cephlon.tech/common/pushMessage";

    // ---- Create nanosecond timestamp like your Java code ----
    const epochMillis = Date.now(); // ms since epoch
    const nanoAdjustment = Math.floor(performance.now() * 1_000_000) % 1_000_000;
    const epochNanos = (epochMillis * 1_000_000) + nanoAdjustment;

    const response = await fetch(url, {
      method: "POST",
      headers: {
        Accept: "*/*",
        "Content-Type": "application/json",
      },
      body: DATA,
    });

    if (!response.ok) {
      console.log("Loki push failed:", response.status);
    } else {
      // Optional success log
      // console.log("Log pushed to Loki");
    }
  } catch (error) {
    console.log("Exception from pushToLoki:", error);
  }
};


  return (
    <FooterStyled>
      <footer className="website-container">
        <div className="first-section section">
          <h3 className="title">
            <img src={logo} alt="logo" onClick={() => navigate(homeUrl)} />
          </h3>
          <h5 className="description">{footerDescription}</h5>
          <div className="footer-input-wrapper">
            <input className="footer-input" placeholder="Enter your Email" onChange={(data)=>{email.current = data.target.value}}/>
            <button className="footer-btn btn-hover" onClick={()=>{submitEmail()}} disabled={buttonDisabled}>Submit</button>
            <img className="mail-icon" src={MailIcon} alt="mailicon" />
          </div>
        </div>
        <div className="second-section section">
          <h3 className="title">{footerContactUsText}</h3>
          {contactsMenu.map((menu, index) => (
            <ContactUsMenu
              key={index}
              logoUrl={menu.logoUrl}
              name={menu.name}
              value={menu.value}
              number={menu.number}
            />
          ))}
        </div>
        <div className="third-section section">
          <h3 className="title">Short Links</h3>
          {shortsLinks.map((link, index) => (
            <Link to={link.link} className="links" key={index}>
              {link.name}
            </Link>
          ))}
          <div
            style={{
              height: "100%",
              display: location.pathname === contactUrl ? "block" : "none",
            }}
          >
            <img
            alt="make in india"
              src={makeInIndia}
              style={{ width: "140px", height: "100%", objectFit: "contain" }}
            />
          </div>
        </div>
        {/* <div className="fourth-section section">
          <h3 className="title">Others</h3>
          {otherLinks.map((link, index) => (
            <Link to={link.link} className="links" key={index}>
              {link.name}
            </Link>
          ))}
        </div> */}
      </footer>
      <div className="last-section">{footerCopyrightsText}</div>
    </FooterStyled>
  );
};

export default Footer;

const ContactUsMenu = ({
  logoUrl = "",
  name = "",
  value = "",
  number = "",
}) => {
  // console.log(value, "[][[]");
  const location = useLocation();
  return (
    <>
      <div className="contact-menu-wrapper">
        <div className="logo">
          {logoUrl !== "" ? <img src={logoUrl} alt="" /> : null}
        </div>
        <div style={{ margin: "auto 0" }}>
          <div className="name">{name}</div>
          <div className="value">{value}</div>
        </div>
      </div>
      <div
        style={{
          display: location.pathname === contactUrl ? "block" : "none",
        }}
      >
        <div style={{ display: number ? "block" : "none", marginTop: "-20px" }}>
          <div
            style={{
              display: "flex",
              gap: "12px",
              alignItems: "center",
              color: "#9a9ea6",
              fontWeight: "400",
            }}
          >
            <img src={Gst} alt="GST"/>
            {number}
          </div>
        </div>
      </div>
    </>
  );
};
